export const CONTACTLIST ="CONTACTLIST"
export const CONTACTDETAILS ="CONTACTDETAILS"
export const CONTACTUPDATESTATUS ="CONTACTUPDATESTATUS"

